import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { numberFormatter } from 'components/atoms/currency-renderer';
import { formatter } from 'components/atoms/input-duration';
import {
  Icon,
  Row,
} from 'components/organisms/projects/project-list/columns/popover-card-components';
import { ProjectHoursPopoverCardProps } from 'components/organisms/projects/project-list/columns/renderer/project-hours';
import { useTranslation } from 'hooks/use-translation';
import { HelperText01 } from 'ozone/atoms';
import { Progress } from '../../organisms/projects/project-list/columns/renderer/project-hours/progress';
import { Widget } from '../../organisms/projects/project-list/columns/renderer/project-hours/widget';

const Container = styled(Row)`
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0;
`;

export const Line = styled.div`
  width: 100%;
  display: flex;
  color: var(--gray-50);
  margin-bottom: var(--spacing-02);
  ${HelperText01} {
    color: var(--gray-50);
  }
`;
export const Info: FC<ProjectHoursPopoverCardProps> = ({
  projectHours: {
    total_minutes,
    budgetMinutes,
    billableMinutes,
    nonBillableHoursFlagEnabled,
  },
}) => {
  const remaining_hours_label = useTranslation('projects.list.remaining_hours');
  const trackedHoursTitle = useTranslation('projects.list.tracked_hours');
  const billableHoursTitle = useTranslation('projects.list.billable_hours');

  const isBudgetMinuteValueNull = budgetMinutes == null;
  const trackedMinutes = nonBillableHoursFlagEnabled
    ? billableMinutes ?? 0
    : total_minutes;
  const minutes_diff = (budgetMinutes ?? 0) - trackedMinutes;
  const remaining_minutes = minutes_diff < 0 ? 0 : minutes_diff;

  return (
    <>
      <Progress
        total_minutes={trackedMinutes}
        budgetMinutes={budgetMinutes}
        width="100%"
        height={16}
      />
      <Container>
        {isBudgetMinuteValueNull ? null : (
          <Widget
            title={
              nonBillableHoursFlagEnabled
                ? billableHoursTitle
                : trackedHoursTitle
            }
            value={formatter(trackedMinutes)}
            percentage={
              isBudgetMinuteValueNull
                ? undefined
                : numberFormatter(
                    (trackedMinutes * 100) / (budgetMinutes || 1) ?? 0,
                  )
            }
          />
        )}

        {isBudgetMinuteValueNull ? null : (
          <Widget
            title={remaining_hours_label}
            value={formatter(remaining_minutes)}
            percentage={numberFormatter(
              (remaining_minutes * 100) / (budgetMinutes || 1) ?? 0,
            )}
          />
        )}
        {isBudgetMinuteValueNull ? (
          <Line>
            <Icon />
            <HelperText01>
              <FormattedMessage id="projects.list.budgeted_hours_missing" />
            </HelperText01>
          </Line>
        ) : (
          <Widget
            title={<FormattedMessage id="projects.list.budgeted_hours" />}
            value={formatter(budgetMinutes)}
          />
        )}
      </Container>
    </>
  );
};
